import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const FormatJobDetails = () => {
  const [inputValue, setInputValue] = useState("");
  const [outputValue, setOutputValue] = useState("");

  const handleFormat = () => {
    // Split the input by new lines and filter out empty lines
    const fields = inputValue.split("\n").map((field) => field.trim()).filter(Boolean);

    // Format the fields and capitalize the first letter of each word after jobDetails
    const formatted = fields
      .map(
        (field) =>
          `${camelCaseField(field)}: jobDetails.${capitalizeField(field)} || "",`
      )
      .join("\n");

    setOutputValue(formatted);
  };

  // Convert the field to camelCase for multi-word fields, otherwise just lowercase the first letter
  const camelCaseField = (field) => {
    const words = field.split(" ");
    if (words.length === 1) {
      // Single word: only lowercase the first letter
      return words[0].charAt(0).toLowerCase() + words[0].slice(1);
    } else {
      // Multiple words: camelCase format
      return words
        .map((word, index) => (index === 0 ? word.toLowerCase() : capitalize(word)))
        .join("");
    }
  };

  // Capitalize the first letter of each word for jobDetails references (e.g., SoldToCompanyName)
  const capitalizeField = (field) => {
    return field
      .split(" ")
      .map((word) => capitalize(word))
      .join("");
  };

  // Capitalize helper function (e.g., Sold or To)
  const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

  return (
    <Container>
      <Row>
        <Col>
          <h3>Format Job Details</h3>
          <Form>
            <Form.Group controlId="inputTextarea">
              <Form.Label>Enter each field on a new line</Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Enter each field on a new line..."
              />
            </Form.Group>

            <Button variant="primary" onClick={handleFormat} className="mt-3">
              Format
            </Button>

            <Form.Group controlId="outputTextarea" className="mt-3">
              <Form.Label>Formatted Output</Form.Label>
              <Form.Control as="textarea" rows={6} value={outputValue} readOnly />
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default FormatJobDetails;
